module.exports = __webpack_public_path__ + "img/approvalOperation.fdc0ba2d.svg";